import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/material/migration/upgrade-to-v10/upgrade-to-v10.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
